(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react')) :
    typeof define === 'function' && define.amd ? define('@fdn/rating-star', ['react'], factory) :
    (global = global || self, global.RatingStar = factory(global.React));
}(this, (function (React) { 'use strict';

    React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;

    var Desktop = function Desktop(props) {
      return /*#__PURE__*/React.createElement("span", {
        className: props.type === 0 ? "cardrv-smstarlist" : "cardrv-starlist"
      }, [1, 2, 3, 4, 5].map(function (item, index) {
        if (props.rating >= item) {
          // return 100%
          return props.type === 0 ? /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_star_small margin-right" : "icon-ic_star_small",
            key: index
          }) : /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_big_star_full margin-right" : "icon-ic_big_star_full",
            key: index
          });
        } else if (props.rating >= item - 0.4) {
          //return 75%
          return props.type === 0 ? /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_star_small_threequarter margin-right" : "icon-ic_star_small_threequarter",
            key: index
          }, /*#__PURE__*/React.createElement("span", {
            className: "path1"
          }), /*#__PURE__*/React.createElement("span", {
            className: "path2"
          })) : /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_big_star_threequarter margin-right" : "icon-ic_big_star_threequarter",
            key: index
          }, /*#__PURE__*/React.createElement("span", {
            className: "path1"
          }), /*#__PURE__*/React.createElement("span", {
            className: "path2"
          }));
        } else if (props.rating >= item - 0.5) {
          // return 50%
          return props.type === 0 ? /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_star_small_half margin-right" : "icon-ic_star_small_half",
            key: index
          }, /*#__PURE__*/React.createElement("span", {
            className: "path1"
          }), /*#__PURE__*/React.createElement("span", {
            className: "path2"
          })) : /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_big_star_half margin-right" : "icon-ic_big_star_half",
            key: index
          }, /*#__PURE__*/React.createElement("span", {
            className: "path1"
          }), /*#__PURE__*/React.createElement("span", {
            className: "path2"
          }));
        } else if (props.rating >= item - 0.9) {
          // return 25%
          return props.type === 0 ? /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_star_small_quarter margin-right" : "icon-ic_star_small_quarter",
            key: index
          }, /*#__PURE__*/React.createElement("span", {
            className: "path1"
          }), /*#__PURE__*/React.createElement("span", {
            className: "path2"
          })) : /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_big_star_quarter margin-right" : "icon-ic_big_star_quarter",
            key: index
          }, /*#__PURE__*/React.createElement("span", {
            className: "path1"
          }), /*#__PURE__*/React.createElement("span", {
            className: "path2"
          }));
        } else {
          // return 0%
          return props.type === 0 ? /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_star_small_grey margin-right" : "icon-ic_star_small_grey",
            key: index
          }) : /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_big_star_grey margin-right" : "icon-ic_big_star_grey",
            key: index
          });
        }
      }), /*#__PURE__*/React.createElement("style", null, "\n              .cardrv-starlist {\n                display: flex;\n              }\n              .cardrv-smstarlist {\n                display: flex;\n              }\n              .cardrv-starlist i {\n                font-size: 20px;\n              }\n              .cardrv-smstarlist i {\n                font-size: 14px;\n              }\n              .cardrv-starlist .margin-right {\n                margin-right: 2.6px;\n              }\n              .cardrv-smstarlist .margin-right {\n                margin-right: 2px;\n              }\n              \n            "));
    };

    var Mobile = function Mobile(props) {
      return /*#__PURE__*/React.createElement("span", {
        className: props.type === 1 ? "review-item-user-starlist" : "cardrv-starlist-sm"
      }, [1, 2, 3, 4, 5].map(function (item, index) {
        if (props.rating >= item) {
          //retun 100%
          return props.type === 1 ? /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_star_small fs12 margin-right" : "icon-ic_star_small fs12",
            key: index
          }) : /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_big_star_full margin-right" : "icon-ic_big_star_full",
            key: index
          });
        } else if (props.rating >= item - 0.4) {
          //return 75%
          return props.type === 1 ? /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_star_small_threequarter fs12 margin-right" : "icon-ic_star_small_threequarter fs12",
            key: index
          }, /*#__PURE__*/React.createElement("span", {
            className: "path1"
          }), /*#__PURE__*/React.createElement("span", {
            className: "path2"
          })) : /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_big_star_threequarter margin-right" : "icon-ic_big_star_threequarter",
            key: index
          }, /*#__PURE__*/React.createElement("span", {
            className: "path1"
          }), /*#__PURE__*/React.createElement("span", {
            className: "path2"
          }));
        } else if (props.rating >= item - 0.5) {
          // return 50%
          return props.type === 1 ? /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_star_small_half fs12 margin-right" : "icon-ic_star_small_half fs12",
            key: index
          }, /*#__PURE__*/React.createElement("span", {
            className: "path1"
          }), /*#__PURE__*/React.createElement("span", {
            className: "path2"
          })) : /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_big_star_half margin-right" : "icon-ic_big_star_half",
            key: index
          }, /*#__PURE__*/React.createElement("span", {
            className: "path1"
          }), /*#__PURE__*/React.createElement("span", {
            className: "path2"
          }));
        } else if (props.rating >= item - 0.9) {
          // return 25%
          return props.type === 1 ? /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_star_small_quarter fs12 margin-right" : "icon-ic_star_small_quarter fs12",
            key: index
          }, /*#__PURE__*/React.createElement("span", {
            className: "path1"
          }), /*#__PURE__*/React.createElement("span", {
            className: "path2"
          })) : /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_big_star_quarter margin-right" : "icon-ic_big_star_quarter",
            key: index
          }, /*#__PURE__*/React.createElement("span", {
            className: "path1"
          }), /*#__PURE__*/React.createElement("span", {
            className: "path2"
          }));
        } else {
          // return 0%
          return props.type === 1 ? /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_star_small_grey fs12 margin-right" : "icon-ic_star_small_grey fs12",
            key: index
          }) : /*#__PURE__*/React.createElement("i", {
            className: item < 5 ? "icon-ic_big_star_grey margin-right" : "icon-ic_big_star_grey",
            key: index
          });
        }
      }), /*#__PURE__*/React.createElement("style", null, "\n             .review-item-user-starlist {\n                display: flex;\n                flex-flow: row;\n                align-items: center;\n                margin: 0;\n              }\n              .review-item-user-starlist i {\n                font-size: 9px;\n              }\n              .cardrv-starlist-sm i {\n                font-size: 9px;\n              }\n              .margin-right {\n                margin-right: 3px;\n              }\n              .cardrv-starlist {\n                display: flex;\n                flex-flow: row;\n                align-items: center;\n                margin: 10px 0;\n              }\n            "));
    };

    var RatingStar = function RatingStar(_ref) {
      var is_mobile = _ref.is_mobile,
          rating = _ref.rating,
          type = _ref.type;
      var props = {
        is_mobile: is_mobile || false,
        rating: rating || 5,
        type: type || 0
      };

      if (is_mobile) {
        return /*#__PURE__*/React.createElement(Mobile, props);
      } else {
        return /*#__PURE__*/React.createElement(Desktop, props);
      }
    };

    return RatingStar;

})));
//# sourceMappingURL=rating_star.umd.js.map
